export default __webpack_public_path__ + "static/media/outline-white2.e8d0041c.png";